export const buttonBoxStylesCP = {
    wrapper: {
        margin: "12px 2% 30px 2%",
        display: "grid",
        gridTemplateColumns: "auto auto auto",
        gap: "8px",
        justifyContent: "center"
    },
    button: {
        height: "40px",
        border: "1px solid #d6d6d6",
        borderRadius: "20px",
        width: "auto !important",        
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#ffffff",
        color: "#474747",
        padding: "0 6px",
        boxSizing: "border-box"
    },
    buttonDisabled: {
        height: "40px",
        border: "1px solid #f5f5f5",
        borderRadius: "20px",
        width: "115px",        
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#ffffff",
        color: "#848484"
    },
    buttonIcon: {
        marginRight: "8px",
        height: "22px",
        width: "22px"
    },
    buttonText: {
        fontSize: "14px",
        fontFamily: "Amx-Bold",
        color: "#999"
    }
}

export const buttonBoxStylesContainerTelcel = {
    wrapper: {
        margin: "12px 2% 30px 2%",
        display: "grid",
        gridTemplateColumns: "max-content max-content",
        gap: "8px",
        justifyContent: "center"
    },
    button: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "40px",
        border: "1px solid #757575",
        borderRadius: "20px",
        background: "#ffffff",
        color: "#222222",
        width: "115px",
        boxSizing: "border-box"
    },
    buttonDisabled: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "40px",
        border: "1px solid #BABABA",
        borderRadius: "20px",
        background: "#ffffff",
        color: "#757575",
        width: "115px"
    },
    buttonIcon: {
        marginRight: "8px",
        height: "22px",
        width: "22px"
    },
    buttonText: {
        position: "relative",
        top: "2px",
        fontFamily: "AMX",
        fontSize: "12px",
        lineHeight: "20px",
    }
}